import { WithStyles, withStyles } from '@mui/styles';
import { SecurityCurrencyAssetPair } from '@tassat/fred-extended-definitions';

import { FirmWalletDetails } from './firmWalletDetails';
import { muiStyles } from './styles';

export interface FirmWalletDetailsProps extends WithStyles<typeof muiStyles> {
    match: any;
    assetPair: SecurityCurrencyAssetPair;
}

export default withStyles(muiStyles)(FirmWalletDetails);